export default __webpack_public_path__ + "static/media/przekaski.6b90ab00.svg";